'use strict';

// Selectors
const pressContainer = document.querySelector('.press');
const mainSection = document.querySelector('.main-content-for-page');
const allModalsContainer = document.querySelector('.all-modals')
const modals = [];
const overlay = document.querySelector('.overlay');
const dotContainer = document.querySelectorAll('.dots');
const header = document.querySelector('.shopify-section-group-header-group');
const btnBackToTop = document.querySelector('.button__container--right');

const imageFile = 'https://cdn.shopify.com/s/files/1/0743/0894/4182/files/';
const leftArrow = imageFile + 'iconarrowleftwhite.svg?v=1689346437'
const rightArrow = imageFile + 'iconarrowrightwhite.svg?v=1689346437'

// List of publications
/*
Copy everything from "{" to "}," (include the comma at the end) and past right after first bracket "["
Update information and copy over links from images you have uploaded
*/
const issues = [
  {
    name: 'Veranda',
    issue: 'March/ April 2025',
    modalTarget: 'Veranda__MarchApril2025',
    coverImg: imageFile + 'Veranda_MarApr25_cover.jpg?v=1740432786',
    modalImgs: [
      imageFile + 'Veranda_MarApr25_40.jpg?v=1740432786'
    ]
  },
  {
    name: 'House Beautiful',
    issue: 'November/ December 2024',
    modalTarget: 'HouseBeautiful__NovemberDecember2024',
    coverImg: imageFile + 'HB_NovDec24_cover.jpg?v=1740167583',
    modalImgs: [
      imageFile + 'HB_NovDec24_story_spread.jpg?v=1740167583', imageFile + 'HB_NovDec24_38-39.jpg?v=1740167583', imageFile + 'HB_NovDec24_40.jpg?v=1740167583', imageFile + 'HB_NovDec24_48-49.jpg?v=1740167583', imageFile + 'HB_NovDec24_50-51.jpg?v=1740167583', imageFile + 'HB_NovDec24_52-53.jpg?v=1740167583', imageFile + 'HB_NovDec24_54-55.jpg?v=1740167583', imageFile + 'HB_NovDec24_56.jpg?v=1740167583', imageFile + 'HB_NovDec24_62-63.jpg?v=1740167583', imageFile + 'HB_NovDec24_64-65.jpg?v=1740167583', imageFile + 'HB_NovDec24_66.jpg?v=1740167583', imageFile + 'HB_NovDec24_68-69.jpg?v=1740167583', imageFile + 'HB_NovDec24_70.jpg?v=1740167583', imageFile + 'HB_NovDec24_72-73.jpg?v=1740167583', imageFile + 'HB_NovDec24_74.jpg?v=1740167583'
    ]
  },
  {
    name: 'House Beautiful',
    issue: 'September/ October 2024',
    modalTarget: 'HouseBeautiful__SeptemberOctober2024',
    coverImg: imageFile + 'HB_SeptOct24_cover.jpg?v=1740432497',
    modalImgs: [
      imageFile + 'HB_SeptOct24_story_spread.jpg?v=1740432497', imageFile + 'HB_SeptOct24_56-57.jpg?v=1740432498', imageFile + 'HB_SeptOct24_story_spread2.jpg?v=1740432498', imageFile + 'HB_SeptOct24_96-97.jpg?v=1740432497'
    ]
  },
   {
    name: 'Southern Living',
    issue: 'September 2024',
    modalTarget: 'southernLiving__September2024',
    coverImg: imageFile + 'SL__Idea_House_2024_Cover.jpg?v=1727293427',
    modalImgs: [
      imageFile + 'SL__Idea_House_2024_Story_Spread.jpg?v=1727293427', imageFile + 'SL__Idea_House_2024_pg88-89.jpg?v=1727293427', imageFile + 'SL__Idea_House_2024_pg92-93.jpg?v=1727293427', imageFile + 'SL__Idea_House_2024_pg95.jpg?v=1727293427', imageFile + 'SL__Idea_House_2024_key_contributors.jpg?v=1727293427'
    ]
  },
  {
    name: 'House Beautiful',
    issue: 'May/June 2024',
    modalTarget: 'houseBeautiful__MayJune2024',
    coverImg: imageFile + 'HB_June24_cover.jpg?v=1721420216',
    modalImgs: [
      imageFile + 'HB_June24_story_spread.jpg?v=1721420216', imageFile + 'HB_June24_50-51.jpg?v=1721420216', imageFile + 'HB_June24_54.jpg?v=1721420216'
    ]
  },
  {
    name: 'House Beautiful',
    issue: 'January/February 2024',
    modalTarget: 'houseBeautiful__JanFeb2024',
    coverImg: imageFile + 'HB_Feb2024_cover.jpg?v=1721419366',
    modalImgs: [
      imageFile + 'HB_Feb2024_Story_Spread.jpg?v=1721419366', imageFile + 'HB_Feb2024_74-75.jpg?v=1721419365', imageFile + 'HB_Feb2024_76-77.jpg?v=1721419366', imageFile + 'HB_Feb2024_79.jpg?v=1721419366'
    ]
  },
   {
    name: 'House Beautiful',
    issue: 'November/December 2023',
    modalTarget: 'houseBeautiful__novDec2023',
    coverImg: imageFile + 'cover_png.webp?v=1706305667',
    modalImgs: [
      imageFile + 'pg6_png.webp?v=1706305666', imageFile + 'story-cover-spread_png.webp?v=1706305667', imageFile + 'pg28_png.webp?v=1706305667', imageFile + 'pg30-31_png.webp?v=1706305667', imageFile + 'pg32-33_png.webp?v=1706305667', imageFile + 'pg42-43_png.webp?v=1706305667', imageFile + 'pg44-45_png.webp?v=1706305666', imageFile + 'pg50-51_png.webp?v=1706305667', imageFile + 'pg52_png.webp?v=1706305667', imageFile + 'pg54-55_png.webp?v=1706305667', imageFile + 'pg56_png.webp?v=1706305667', imageFile + 'pg58-59_png.webp?v=1706305667', imageFile + 'pg60-61_png.webp?v=1706305667', imageFile + 'pg64-65_png.webp?v=1706305667', imageFile + 'pg66-67_png.webp?v=1706305667', imageFile + 'pg68-69_png.webp?v=1706305667', imageFile + 'pg70-71_png.webp?v=1706305666', imageFile + 'pg72-73_png.webp?v=1706305667', imageFile + 'pg74-75_png.webp?v=1706305667', imageFile + 'resources_png.webp?v=1706305667'
    ]
  },
   {
    name: 'Luxe Interiors + Design',
    issue: 'November/December 2023',
    modalTarget: 'luxeInteriors__novDec2023',
    coverImg: imageFile + 'Luxe-Pacific-Northwest_Nov_Dec_2023_cover_png.webp?v=1706305667',
    modalImgs: [
      imageFile + 'Luxe-Pacific-Northwest_Nov_Dec_2023_spread_png.webp?v=1706305666'
    ]
  },
    {
    name: 'Southern Living',
    issue: 'September 2023',
    modalTarget: 'southerLiving__sept2023',
    coverImg: imageFile + 'cover-_png.webp?v=1706305666',
    modalImgs: [
      imageFile + 'SL-Idea-House-_png.webp?v=1706305667', imageFile + '98-99_png.webp?v=1706305666', imageFile + '102-103_png.webp?v=1706305667', imageFile + '116_wallcovernig-_png.webp?v=1706305666', imageFile + 'Meet-the-Team_png.webp?v=1706305666', imageFile + 'contributors-_png.webp?v=1706305667'
    ]
  },
  {
    name: 'Veranda',
    issue: 'July/August 2023',
    modalTarget: 'veranda__JulyAug2023',
    coverImg: imageFile + 'Veranda_Aug2023_cover.jpg?v=1721422378',
    modalImgs: [
      imageFile + 'Veranda_Aug2023_Story1_spread.jpg?v=1721422378', imageFile + 'Veranda_Aug2023_Story1_28.jpg?v=1721422378', imageFile + 'Veranda_Aug2023_Story2_spread.jpg?v=1721422378', imageFile + 'Veranda_Aug2023_Story2_84-85.jpg?v=1721422378', imageFile + 'Veranda_Aug2023_Story2_source.jpg?v=1721422378'
    ]
  },
  {
    name: 'House Beautiful',
    issue: 'Spring 2023',
    modalTarget: 'houseBeautiful__spring2023',
    coverImg: imageFile + 'Spring-2023-cover.webp?v=1689279049',
    modalImgs: [
      imageFile + 'The-Big-Chill_p84.webp?v=1689279049', imageFile + 'p88.webp?v=1689279049', imageFile + 'Opal_p104.webp?v=1689279049', imageFile + 'resources1.webp?v=1689279049'
    ]
  },
  {
    name: 'Veranda',
    issue: 'January/ February 2023',
    modalTarget: 'Veranda__JanuaryFebruary2023',
    coverImg: imageFile + 'Veranda_JanFeb23_cover.jpg?v=1740497682',
    modalImgs: [
      imageFile + 'Veranda_JanFeb23_storyspread.jpg?v=1740497682', imageFile + 'Veranda_JanFeb23_98-99.jpg?v=1740497682', imageFile + 'Veranda_JanFeb23_100-101.jpg?v=1740497682', imageFile + 'Veranda_JanFeb23_104.jpg?v=1740497682', imageFile + 'Veranda_JanFeb23_120-121.jpg?v=1740497682'
    ]
  },
  {
    name: 'House Beautiful',
    issue: 'December 2022',
    modalTarget: 'houseBeautiful__december2022',
    coverImg: imageFile + 'Cover_d0cd94d8-ff3a-4431-8618-43b8791cf67d.webp?v=1687206050',
    modalImgs: [
      imageFile + '9293.webp?v=1687206010', imageFile + '9495.webp?v=1687206009', imageFile + '9697Gatsby.webp?v=1687206008', imageFile + '9899Gatsby.webp?v=1687206008', imageFile + '104105Siskiyou.webp?v=1687206009', imageFile + '116117Mermaid.webp?v=1687206009', imageFile + '118119Savile.webp?v=1687206009', imageFile + '122123Viper.webp?v=1687206009', imageFile + 'Resources.webp?v=1687206092'
    ]
  },
  {
    name: 'House Beautiful',
    issue: 'October/November 2022',
    modalTarget: 'houseBeautiful__octNov2022',
    coverImg: imageFile + 'Cover-1.webp?v=1687206050',
    modalImgs: [
      imageFile + 'spread1.webp?v=1687206090', imageFile + 'spread2.webp?v=1687206091'
    ]
  },
  {
    name: 'Southern Living',
    issue: 'October 2022',
    modalTarget: 'southernLiving__oct2022',
    coverImg: imageFile + 'cover-2_46ec27f3-8b7c-4703-b0a7-13dd2a9c1fc4.webp?v=1687206050',
    modalImgs: [
      imageFile + '77.webp?v=1687206008', imageFile + '8081.webp?v=1687206009', imageFile + 'sourcepg.webp?v=1687206091'
    ]
  },
  {
    name: 'Luxe Interiors + Design',
    issue: 'July/August 2022',
    modalTarget: 'luxe__julyAug2022',
    coverImg: imageFile + 'Luxecover.webp?v=1687206091',
    modalImgs: [
      imageFile + 'Luxe1.webp?v=1687206090', imageFile + 'Luxe3.webp?v=1687206090'
    ]
  },
  {
    name: 'Connecticut Cottages and Gardens',
    issue: 'September 2022',
    modalTarget: 'ctcg__september2022',
    coverImg: imageFile + 'CTCGSeptember2022cover.webp?v=1687206051',
    modalImgs: [
      imageFile + 'CTCGSeptember2022Page2.webp?v=1687206052', imageFile + 'CTCGSeptember2022Page3.webp?v=1687206052'
    ]
  },
  {
    name: 'Traditional Home',
    issue: 'Spring 2022',
    modalTarget: 'traditionalHome__spring2022',
    coverImg: imageFile + 'TraditionalHomecover.webp?v=1687206090',
    modalImgs: [
      imageFile + 'TraditionalHomeClassReunion1.webp?v=1687206091', imageFile + 'TraditionalHomeClassReunion2.webp?v=1687206091', imageFile + 'TraditionalHomeClassReunion3.webp?v=1687206091', imageFile + 'TraditionalHomeClassReunion4.webp?v=1687206091', imageFile + 'TraditionalHomeTropicalPunch1.webp?v=1687206091', imageFile + 'TraditionalHomeTropicalPunch2.webp?v=1687206091', imageFile + 'TraditionalHomeTropicalPunch3.webp?v=1687206091', imageFile + 'TraditionalHomeTropicalPunch4.webp?v=1687206090', imageFile + 'TraditionalHomeResources.webp?v=1687206091'
    ]
  },
  {
    name: 'Veranda',
    issue: 'March/April 2022',
    modalTarget: 'veranda__marApr2022',
    coverImg: imageFile + 'Verandacover.webp?v=1687206091',
    modalImgs: [
      imageFile + 'VerandaANewDawnintheDelta1.webp?v=1687206091', imageFile + 'VerandaANewDawnintheDelta2.webp?v=1687206091', imageFile + 'VerandaANewDawnintheDelta3.webp?v=1687206090', imageFile + 'VerandaANewDawnintheDelta4.webp?v=1687206091', imageFile + 'VerandaSourceBook.webp?v=1687206091'
    ]
  },
  {
    name: 'Southern Living',
    issue: 'March 2022',
    modalTarget: 'southernLiving__mar2022',
    coverImg: imageFile + 'SouthernLivingcover.webp?v=1687206091',
    modalImgs: [
      imageFile + 'SouthernLiving1.webp?v=1687206091', imageFile + 'SouthernLiving2.webp?v=1687206091'
    ]
  },
  {
    name: 'Southern Living',
    issue: 'January/February 2022',
    modalTarget: 'southernLiving__janFeb2022',
    coverImg: imageFile + 'SouthernLivingJanuaryFebruary2022cover.webp?v=1687206091',
    modalImgs: [
      imageFile + 'SouthernLivingJanuaryFebruary20221.webp?v=1687206091', imageFile + 'SouthernLivingJanuaryFebruary20222.webp?v=1687206091'
    ]
  },
   {
    name: 'Home Accents Today',
    issue: 'Las Vegas January 2022',
    modalTarget: 'hat__jan2022',
    coverImg: imageFile + 'PRESS.webp?v=1687206090',
    modalImgs: [
      imageFile + 'HomeAccentsTodayLasVegasJanuary242022.webp?v=1687206050'
    ]
  },
   {
    name: 'House Beautiful',
    issue: 'October/November 2021',
    modalTarget: 'houseBeautiful__octNov2021',
    coverImg: imageFile + 'WHAnniversary.webp?v=1687206091',
    modalImgs: [
      imageFile + 'HBX100121WholeHome2lo3Page2.webp?v=1687206053', imageFile + 'HBX100121WholeHome2lo3Page4.webp?v=1687206053', imageFile + 'HBX100121WholeHome2lo3Page5.webp?v=1687206054', imageFile + 'HBX100121WholeHome2lo3Page7.webp?v=1687206054', imageFile + 'HBX100121WholeHome2lo3Page8.webp?v=1687206054'
    ]
  },
   {
    name: 'Southern Living',
    issue: 'October 2021',
    modalTarget: 'southernLiving__oct2021',
    coverImg: imageFile + 'cover-3.webp?v=1687206049',
    modalImgs: [
      imageFile + 'PathwaySpread6667.webp?v=1687206091', imageFile + 'Siskiyou6869.webp?v=1687206091', imageFile + 'Siskiyouad.webp?v=1687206090', imageFile + 'Togo7677.webp?v=1687206091', imageFile + 'Kochi78.webp?v=1687206090', imageFile + 'Sponsors9293.webp?v=1687206091'
    ]
  },
  {
    name: 'Vision',
    issue: 'March/April 2021',
    modalTarget: 'vision__marApr2021',
    coverImg: imageFile + 'WFVisionMarApr21cover.webp?v=1687206091',
    modalImgs: [
      imageFile + 'WFVisionMarApr2152.webp?v=1687206090', imageFile + 'WFVisionMarApr2153.webp?v=1687206090', imageFile + 'WFVisionMarApr2154.webp?v=1687206092', imageFile + 'WFVisionMarApr2155.webp?v=1687206092'
    ]
  },
   {
    name: 'Designers Today',
    issue: 'December 2020',
    modalTarget: 'desToday__dec2020',
    coverImg: imageFile + 'cover-4.webp?v=1687206049',
    modalImgs: [
      imageFile + 'spread.webp?v=1687206090'
    ]
  },
   {
    name: 'Southern Living',
    issue: 'October 2020',
    modalTarget: 'southernLiving__oct2020',
    coverImg: imageFile + 'cover_3047c072-f0a1-4704-ab8c-93d466e2a6a0.webp?v=1687206051',
    modalImgs: [
      imageFile + '1_95c82aba-f5ef-4f4b-a35f-824b30e90630.webp?v=1687206009', imageFile + '2.webp?v=1687206009', imageFile + '3-1_jpg.webp?v=1687206008'
    ]
  },
   {
    name: 'Country Living',
    issue: 'September 2020',
    modalTarget: 'countryLiving__sep2020',
    coverImg: imageFile + 'cover-1_jpg.webp?v=1687206050',
    modalImgs: [
      imageFile + '1-1_jpg.webp?v=1687206010', imageFile + '2-1_jpg.webp?v=1687206009', imageFile + '3_92d429d5-c789-4a22-867f-9b7bfb1f3289.webp?v=1687206009', imageFile + '4_d17df48e-e445-48ac-8cc9-cd3c733f9ba8.webp?v=1687206009', imageFile + '5_60dc6860-c333-47bb-ba36-edc4f3dbbd6e.webp?v=1687206009', imageFile + '6-scaled.webp?v=1689610068'
    ]
  },
   {
    name: 'American Farmhouse',
    issue: 'April/May 2020',
    modalTarget: 'amFarmhouse__aprMay2020',
    coverImg: imageFile + 'cover-2.webp?v=1687206049',
    modalImgs: [
      imageFile + '1-2.webp?v=1687206006', imageFile + '2-2.webp?v=1687206006'
    ]
  },
   {
    name: 'Southern Living',
    issue: 'August 2019',
    modalTarget: 'southernLiving__aug2019',
    coverImg: imageFile + 'cover-3_bcb89ad2-0361-489c-8e18-e417514655e3.webp?v=1687206051',
    modalImgs: [
      imageFile + '1-scaled.webp?v=1689610627', imageFile + '2scaled.webp?v=1687206010', imageFile + '3scaled.webp?v=1687206010', imageFile + '4scaled.webp?v=1687206009', imageFile + '5scaled.webp?v=1687206010', imageFile + '6scaled-1_jpg.webp?v=1687206010', imageFile + '7scaled.webp?v=1687206010'
    ]
  },
   {
    name: 'Southern Living',
    issue: 'July 2019',
    modalTarget: 'southernLiving__july2019',
    coverImg: imageFile + 'coverscaled.webp?v=1687206052',
    modalImgs: [
      imageFile + '1scaled-1_jpg.webp?v=1687206010'
    ]
  },
  {
    name: 'Southern Living',
    issue: 'May 2019',
    modalTarget: 'southernLiving__may2019',
    coverImg: imageFile + 'cover-5_b83148c5-54d8-46e1-8ed4-a5be971afcb9.webp?v=1687206051',
    modalImgs: [
      imageFile + '1.webp?v=1687206009', imageFile + '2_86eb2e53-a211-4cf3-877f-8c7b2af3fbda.webp?v=1687206009', imageFile + '3.webp?v=1687206009', imageFile + '4.webp?v=1687206009', imageFile + '5.webp?v=1687206008'
    ]
  },
  {
    name: 'Connecticut Cottages and Gardens',
    issue: 'December 2018',
    modalTarget: 'ctcg__december2018',
    coverImg: imageFile + 'Cover.webp?v=1687206048',
    modalImgs: [
      imageFile + '1-3.webp?v=1687206008'
    ]
  },
    {
    name: 'House Beautiful',
    issue: 'October 2018',
    modalTarget: 'houseBeautiful__oct2018',
    coverImg: imageFile + 'cover-4_151d4bdc-0013-43fd-a9fe-28fd5ea3a8c9.webp?v=1687206051',
    modalImgs: [
      imageFile + '2-3.webp?v=1687206007', imageFile + '3-2.webp?v=1687206008', imageFile + '1-4.webp?v=1687206008'
    ]
  },
    {
    name: 'House Beautiful',
    issue: 'April 2018',
    modalTarget: 'houseBeautiful__apr2018',
    coverImg: imageFile + 'cover-5.webp?v=1687206051',
    modalImgs: [
      imageFile + '1-5.webp?v=1687206008', imageFile + '2-4.webp?v=1687206008'
    ]
  },
   {
    name: 'Country Living',
    issue: 'March 2018',
    modalTarget: 'countryLiving__mar2018',
    coverImg: imageFile + 'cover1.webp?v=1687206050',
    modalImgs: [
      imageFile + '11_b689205b-6b4e-4272-93b7-d0ce29de4321.webp?v=1687206009', imageFile + '21_77ab4340-e271-4941-aa0b-1d012fcf2e6a.webp?v=1687206009'
    ]
  },
   {
    name: 'Coastal Living',
    issue: 'November 2017',
    modalTarget: 'coastalLiving__nov2017',
    coverImg: imageFile + 'cover11.webp?v=1687206051',
    modalImgs: [
      imageFile + '111.webp?v=1687206008'
    ]
  },
  {
    name: 'Atlanta Homes',
    issue: 'September 2017',
    modalTarget: 'atlantaHomes__sep2017',
    coverImg: imageFile + 'cover2scaled.webp?v=1687206051',
    modalImgs: [
      imageFile + '12scaled.webp?v=1687206010', imageFile + 'multiple.webp?v=1687206091'
    ]
  },
   {
    name: 'Coastal Living',
    issue: 'September 2017',
    modalTarget: 'coastalLiving__sep2017',
    coverImg: imageFile + 'cover1-1_jpg.webp?v=1687206050',
    modalImgs: [
      imageFile + '12.webp?v=1687206009'
    ]
  },
   {
    name: 'Country Living',
    issue: 'September 2017',
    modalTarget: 'countryLiving__sep2017',
    coverImg: imageFile + 'cover10.webp?v=1687206051',
    modalImgs: [
      imageFile + '110.webp?v=1687206009'
    ]
  },
   {
    name: 'Traditional Home',
    issue: 'September 2017',
    modalTarget: 'traditionalHome__sep2017',
    coverImg: imageFile + 'cover7.webp?v=1687206051',
    modalImgs: [
      imageFile + '17.webp?v=1687206008'
    ]
  },
   {
    name: 'Country Living',
    issue: 'July/August 2017',
    modalTarget: 'countryLiving__julyAug2017',
    coverImg: imageFile + 'cover8.webp?v=1687206051',
    modalImgs: [
      imageFile + '18.webp?v=1687206008', imageFile + '24.webp?v=1687206007'
    ]
  },
   {
    name: 'Traditional Home',
    issue: 'July/August 2017',
    modalTarget: 'traditionalHome__julyAug2017',
    coverImg: imageFile + 'cover2.webp?v=1687206051',
    modalImgs: [
      imageFile + '11-1_jpg.webp?v=1687206008'
    ]
  },
  {
    name: 'Coastal Living',
    issue: 'December 2016/January 2017',
    modalTarget: 'coastalLiving__dec2016jan2017',
    coverImg: imageFile + 'cover9.webp?v=1687206050',
    modalImgs: [
      imageFile + '11-2.webp?v=1687206008'
    ]
  },
   {
    name: 'House Beautiful',
    issue: 'November 2016',
    modalTarget: 'houseBeautiful__nov2016',
    coverImg: imageFile + 'cover7-1_jpg.webp?v=1687206051',
    modalImgs: [
      imageFile + '17-1_jpg.webp?v=1687206009'
    ]
  },
    {
    name: 'Traditional Home',
    issue: 'October 2016',
    modalTarget: 'traditionalHome__oct2016',
    coverImg: imageFile + 'cover3.webp?v=1687206051',
    modalImgs: [
      imageFile + '1-6.webp?v=1687206008'
    ]
  },
   {
    name: 'House Beautiful',
    issue: 'March 2016',
    modalTarget: 'houseBeautiful__mar2016',
    coverImg: imageFile + 'cover6.webp?v=1687206050',
    modalImgs: [
      imageFile + '16.webp?v=1687206009'
    ]
  },
   {
    name: 'Traditional Home',
    issue: 'July/August 2016',
    modalTarget: 'traditionalHome__julyAug2016',
    coverImg: imageFile + 'cover4.webp?v=1687206051',
    modalImgs: [
      imageFile + '2-5.webp?v=1687206008'
    ]
  },
   {
    name: 'Southern Living',
    issue: 'January 2016',
    modalTarget: 'southernLiving__jan2016',
    coverImg: imageFile + 'cover5.webp?v=1687206051',
    modalImgs: [
      imageFile + '14-1_jpg.webp?v=1687206007', imageFile + '22.webp?v=1687206008'
    ]
  },
    {
    name: 'Trad Home',
    issue: 'Spring 2015',
    modalTarget: 'tradHome__spring2015',
    coverImg: imageFile + 'cover6-1_jpg.webp?v=1687206049',
    modalImgs: [
      imageFile + '14.webp?v=1687206009'
    ]
  },
    {
    name: 'Traditional Home',
    issue: 'February/March 2015',
    modalTarget: 'traditionalHome__febMar2015',
    coverImg: imageFile + 'cover3-1_jpg.webp?v=1687206051',
    modalImgs: [
      imageFile + '13.webp?v=1687206008'
    ]
  },
    {
    name: 'Southern Living',
    issue: 'July 2014',
    modalTarget: 'southernLiving__july2014',
    coverImg: imageFile + 'cover-6.webp?v=1687206051',
    modalImgs: [
      imageFile + '15.webp?v=1687206007', imageFile + '23.webp?v=1687206007', imageFile + '3-3.webp?v=1687206006'
    ]
  },
    {
    name: 'Traditional Home',
    issue: 'May 2014',
    modalTarget: 'traditionalHome__may2014',
    coverImg: imageFile + 'cover4-1_jpg.webp?v=1687206051',
    modalImgs: [
      imageFile + '15-1_jpg.webp?v=1687206008'
    ]
  },
  {
    name: 'Traditional Home',
    issue: 'April 2013',
    modalTarget: 'traditionalHome__apr2013',
    coverImg: imageFile + 'cover1_57ad6608-15a7-4882-b23d-65fa5aa8c380.webp?v=1687206051',
    modalImgs: [
      imageFile + '11.webp?v=1687206008', imageFile + '22_0fe04624-b094-430a-8eb4-98e18afe0f4e.webp?v=1687206009', imageFile + '31.webp?v=1687206009', imageFile + '41.webp?v=1687206009', imageFile + '51.webp?v=1687206009', imageFile + '6.webp?v=1687206009'
    ]
  },
    {
    name: 'Traditional Home',
    issue: 'February/March 2013',
    modalTarget: 'traditionalHome__febMar2013',
    coverImg: imageFile + 'cover8-1_jpg.webp?v=1687206050',
    modalImgs: [
      imageFile + '18-1_jpg.webp?v=1687206007', imageFile + '21.webp?v=1687206009'
    ]
  },
   {
    name: 'Traditional Home',
    issue: 'June 2012',
    modalTarget: 'traditionalHome__june2012',
    coverImg: imageFile + 'cover5-1_jpg.webp?v=1687206051',
    modalImgs: [
      imageFile + '16-1_jpg.webp?v=1687206007'
    ]
  }
]


// Modal
issues.forEach(function(obj, i) {
  const html = `
  <div class="press__item">
    <div class="cover-img" data-toggle="modal" data-target="#modal--${obj.modalTarget}">
      <img src="${obj.coverImg}" width="300px" height="320px" loading="lazy">
    </div>
    <div class="press__description">
      <h3 class="press__title">${obj.name}</h3>
      <p class="press__date">${obj.issue}</p>
    </div>
  </div>
  `
  pressContainer.insertAdjacentHTML('beforeend', html);

  const modal = `
  <div class="modal modal-hidden" id="modal--${obj.modalTarget}">
    <div class="left-arrow arrow" id="left-arrow__modal--${i}">
      <figure class="left-arrow-svg">
        <img src=${leftArrow} width="75px" height="75px">
      </figure>
    </div>
    <div class="modal__body">
      <div class="press__slider" id="modal--${i}">
      </div>
      <div class="dots"></div>
    </div>
    <div class="right-arrow arrow" id="right-arrow__modal--${i}">
      <figure class="right-arrow-svg">
        <img src=${rightArrow} width="75px" height="75px">
      </figure>
    </div>
  </div>
  `
  allModalsContainer.insertAdjacentHTML('beforeend', modal);
  modals.push(document.getElementById(`modal--${i}`));
});

for (const obj of issues) {
  const modalImages = [obj.coverImg].concat(obj.modalImgs);
  // console.log(modalImages);
  modalImages.forEach(function(img, i) {
    const html = `
      <div class="modal-item" id="${obj.modalTarget}--${i}">
        <figure class="modal-image">
          <img src="${img}" id="${obj.modalTarget}--${i}__image" loading="lazy">
        </figure>
      </div>
    `

    // console.log(modals[issues.indexOf(obj)])

    modals[issues.indexOf(obj)].insertAdjacentHTML('beforeend', html);
  })
}

const openModal = function(modal) {
  document.querySelector(modal).classList.remove('modal-hidden');
  overlay.classList.remove('overlay-hidden');
}

const closeModal = function() {
  overlay.classList.add('overlay-hidden');
  allModals.forEach(function(modal) {
    modal.classList.add('modal-hidden');
    modal.classList.remove('modal-active');
    setTimeout(() => goToSlide(modal, 0), 500);
  });
  curSlide = 0;
}

pressContainer.addEventListener('click', function(e) {
  e.preventDefault();
  const modalChoice = e.target.closest('.press__item').firstElementChild.getAttribute('data-target');
  const modalActive = document.querySelector(modalChoice);
  modalActive.classList.add('modal-active');
  openModal(modalChoice);
  activateDot(modalActive, 0);
  curModal = modalActive;
})

overlay.addEventListener('click', closeModal);

// Slider
const allModals = document.querySelectorAll('.modal');
const btnLeft = document.querySelectorAll('.left-arrow');
const btnRight = document.querySelectorAll('.right-arrow');

const createDots = function() {
  allModals.forEach((modal, i) => {
    modal.querySelectorAll('.modal-item').forEach((item, index) => {
      item.closest('.modal__body').querySelector('.dots').insertAdjacentHTML(
      'beforeend',
      `<button class="dots__dot" data-slide="${index}"></button>`
    )}
    )                                                  
  })
}

const activateDot = function (modal, slide) {
    document
      .querySelectorAll('.dots__dot')
      .forEach(dot => dot.classList.remove('dots__dot--active'));
    modal
      .querySelector(`.dots__dot[data-slide="${slide}"]`)
      .classList.add('dots__dot--active');
  };

let curSlide = 0;
let curModal;
// console.log(allModals);
allModals.forEach(function(modal) {
  const modalItems = modal.querySelectorAll('.modal-item');
  modalItems.forEach(function(item, i) {
    item.style.transform = `translateX(${100 * i}%`
  })
  
})

const goToSlide = function (modal, slide) {
    modal.querySelectorAll('.modal-item').forEach(
      (s, i) => (s.style.transform = `translateX(${100 * (i - slide)}%)`)
    );
};

const nextSlide = function (target) {
  // const curModal = document.querySelector('.modal-active');
  const maxSlide = curModal.querySelectorAll('.modal-item').length;
    if (curSlide === maxSlide - 1) {
      curSlide = 0;
    } else {
      curSlide++;
    }
    goToSlide(curModal, curSlide);
    activateDot(curModal, curSlide);
};

const prevSlide = function (target) {
  // console.log(this);
  // const curModal = document.querySelector('.modal-active');
  const maxSlide = curModal.querySelectorAll('.modal-item').length;
    if (curSlide === 0) {
      curSlide = maxSlide - 1;
    } else {
      curSlide--;
    }
    goToSlide(curModal, curSlide);
    activateDot(curModal, curSlide);
};

btnBackToTop.addEventListener('click', function(e) {
    header.scrollIntoView({behavior: 'smooth'})
})

const init = function () {
  createDots();
  allModals.forEach((modal) => activateDot(modal, 0))
}
init();

// Event Listeners
allModalsContainer.addEventListener('click', function(e) {
  // console.log(e.target);
  if (!e.target.closest('.arrow')) return;
  if (e.target.closest('.arrow').classList.contains('left-arrow')) {
    // console.log('left-arrow');
    prevSlide(e.target);
  } else if (e.target.closest('.arrow').classList.contains('right-arrow')) {
    // console.log('right-arrow');
    nextSlide(e.target);
  }
});

document.addEventListener('keydown', function (e) {
  // console.log(e.key);
  if (e.key === 'Escape') closeModal();
  if (overlay.classList.contains('overlay-hidden')) return;
  if (e.key === 'ArrowLeft') prevSlide();
  if (e.key === 'ArrowRight') nextSlide();
})

allModalsContainer.addEventListener('click', function(e) {
  if (e.target.classList.contains('dots__dot')) {
    const {slide} = e.target.dataset;
    const modal = e.target.closest('.modal');
    goToSlide(modal, slide);
    activateDot(modal, slide);
    curSlide = Number(slide);
  }
})